document.addEventListener('DOMContentLoaded', () => {
  var instances = new WeakMap();
  var retryTimer = null;

  function clearRetry() {
    if (retryTimer !== null) {
      window.clearInterval(retryTimer);
      retryTimer = null;
    }
  }

  function scheduleRetry() {
    if (retryTimer !== null) return;

    // Swiper 在主题里 defer 加载，section 脚本可能先执行；短轮询等待全局 Swiper 就绪。
    retryTimer = window.setInterval(function () {
      if (typeof window.Swiper === 'undefined') return;
      clearRetry();
      initAll();
    }, 50);

    window.setTimeout(clearRetry, 5000);
  }

  function initSection(section) {
    if (!section || instances.has(section)) return;

    var swiperEl = section.querySelector('.engraved-page-products__swiper');
    if (!swiperEl) return;

    if (typeof window.Swiper === 'undefined') {
      scheduleRetry();
      return;
    }

    // slidesPerView 使用 auto，真实卡片宽度交给 CSS 控制，便于 PC/M 端分别还原设计尺寸。
    var swiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      watchOverflow: true,
      simulateTouch: true,
      passiveListeners: true,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      navigation: {
        prevEl: section.querySelector('.engraved-page-products__nav-button--prev'),
        nextEl: section.querySelector('.engraved-page-products__nav-button--next'),
      },
      pagination: {
        el: section.querySelector('.engraved-page-products__pagination'),
        clickable: true,
      },
    });

    instances.set(section, swiper);
  }

  function destroySection(section) {
    var swiper = instances.get(section);
    if (!swiper) return;

    // 主题编辑器卸载 section 时销毁实例，避免重复绑定和残留 transform。
    swiper.destroy(true, true);
    instances.delete(section);
  }

  function initAll() {
    document.querySelectorAll('[data-engraved-products]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-engraved-products]')) {
      initSection(event.target.querySelector('[data-engraved-products]'));
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.querySelector('[data-engraved-products]')) {
      destroySection(event.target.querySelector('[data-engraved-products]'));
    }
  });
});
